import React, { useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography, useMediaQuery } from '@mui/material';
import PersonCard from './PersonInfoForm/PersonCard';
import { useSelector } from 'react-redux';
import PersonInfoForm from './PersonInfoForm/PersonInfoForm';
import WholeScreenSkeleton from '../Misc/WholeScreenSkeleton copy';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ClickIcon from '@mui/icons-material/Mouse';
import { AnalyticsCard } from './AnalyticsCard';

const HomePage = () => {
    const smallScreen = useMediaQuery('(max-width:1250px)');
    const onMobile = useMediaQuery('(max-width:600px)');
    const { loggedIn, loadingMetadata, loggingOut } = useSelector(state => state.auth);

    useEffect(() => {}, [loadingMetadata, loggingOut]);

    // Dummy data
    const generateDummyData = () => {
        const days = Array.from({ length: 30 }, (_, i) => `Day ${i + 1}`);
        const generateRandomValues = () =>
        Array.from({ length: 30 }, () => Math.floor(Math.random() * 1000));
    
        return {
            days,
            views: generateRandomValues(),
            clicks: generateRandomValues(),
            conversions: generateRandomValues(),
        };
    };
    const data = generateDummyData();

    return (
        <>
            {loadingMetadata || loggingOut ? 
                <WholeScreenSkeleton /> 
                : 
                loggedIn &&
                    <Box sx={{
                        marginTop: "4rem"
                    }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                            <AnalyticsCard
                                title="Views"
                                icon={<VisibilityIcon color="primary" />}
                                x={data.days}
                                y={data.views}
                            />
                            </Grid>
                            <Grid item xs={12} md={4}>
                            <AnalyticsCard
                                title="Clicks"
                                icon={<ClickIcon color="secondary" />}
                                x={data.days}
                                y={data.clicks}
                            />
                            </Grid>
                            <Grid item xs={12} md={4}>
                            <AnalyticsCard
                                title="Conversions"
                                icon={<TrendingUpIcon color="success" />}
                                x={data.days}
                                y={data.conversions}
                            />
                            </Grid>
                        </Grid>
                    </Box>
                   
            }
        </>
    );
}


export default HomePage;
